import React from "react";
import { getTokenData } from "../../../shared/utils/utils";

const columnsCache = {};

export function useSheetColumns(sheetCode) {
  const [columns, setColumns] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);

  const fetchColumns = React.useCallback(
    async (force = false) => {
      if (!sheetCode) {
        setColumns([]);
        return;
      }

      if (!force && columnsCache[sheetCode]) {
        setColumns(columnsCache[sheetCode]);
        return;
      }

      let isMounted = true;

      try {
        setLoading(true);
        setError(null);

        const { token, client_id } = await getTokenData();

        if (!token || !client_id) {
          throw new Error("Sessão inválida");
        }

        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_AWS_URL}/sheets/variables/check?code=${sheetCode}`,
          {
            headers: {
              Authorization: token,
              Client_ID: client_id,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Erro ao buscar colunas");
        }

        const data = await response.json();

        const mappedColumns = (data?.data || [])
          .map((item) => {
            const id = item?.id ?? item?.column_id ?? null;
            const title =
              item?.title ?? item?.name ?? item?.variable ?? item?.field ?? "";
            const column =
              item?.column ?? item?.field ?? item?.variable ?? null;

            if (id === null || !title) return null;

            return {
              id,
              title,
              column,
            };
          })
          .filter(Boolean);

        columnsCache[sheetCode] = mappedColumns;

        if (isMounted) {
          setColumns(mappedColumns);
        }
      } catch (err) {
        console.error("Erro ao obter colunas:", err);
        setError(err);
      } finally {
        setLoading(false);
      }

      return () => {
        isMounted = false;
      };
    },
    [sheetCode]
  );

  React.useEffect(() => {
    fetchColumns();
  }, [fetchColumns]);

  return {
    columns,
    loading,
    error,
    refetch: () => fetchColumns(true),
  };
}
